import { Button, Result } from 'antd'
import { useNavigate } from 'react-router'

interface LoadErrorProps {
  title?: string
  subTitle?: string
  backTo?: string
  backLabel?: string
}

const LoadError = ({
  title = 'Failed to load',
  subTitle = 'An error occurred. Please try again.',
  backTo = '/',
  backLabel = 'Go back',
}: LoadErrorProps) => {
  const navigate = useNavigate()

  return (
    <Result
      status="error"
      title={title}
      subTitle={subTitle}
      extra={<Button type="primary" onClick={() => navigate(backTo)}>{backLabel}</Button>}
    />
  )
}

export default LoadError
